var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageUpload = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1665 1H10.6665C7.4005 1 5.7675 1 4.51277 1.61876C3.32818 2.20294 2.36945 3.16167 1.78527 4.34627C1.1665 5.601 1.1665 7.234 1.1665 10.5V11.4C1.1665 14.7603 1.1665 16.4405 1.82046 17.7239C2.39571 18.8529 3.31359 19.7708 4.44256 20.346C5.72603 21 7.40619 21 10.7665 21H11.6665C14.9325 21 16.5655 21 17.8202 20.3812C19.0048 19.7971 19.9636 18.8383 20.5477 17.6537C21.1665 16.399 21.1665 14.766 21.1665 11.5V11M20.6665 16.6875L19.2418 15.2627C18.4497 14.4707 18.0537 14.0747 17.597 13.9263C17.1954 13.7958 16.7627 13.7958 16.361 13.9263C15.9043 14.0747 15.5081 14.4709 14.7158 15.2633L13.6526 16.3264M1.6665 17.5L5.93694 13.2296C6.71847 12.448 7.10924 12.0573 7.56078 11.9083C7.95805 11.7773 8.38641 11.7741 8.78557 11.8993C9.23927 12.0415 9.63577 12.4265 10.4288 13.1964L13.6526 16.3264M13.6526 16.3264L17.6665 20.3403M17.1665 8V2M17.1665 2L14.6665 4.5M17.1665 2L19.6665 4.5",
    stroke: "#AEB0BC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageUpload);
export default ForwardRef;